export const createInterval = (
  setStateCallback: React.Dispatch<React.SetStateAction<number>>, // React state setter
  duration?: number,
  onComplete?: () => void,
  maxIterations?: number
) => {
  const interval = setInterval(() => {
    setStateCallback(prevIndex => {
      if (prevIndex + 1 < (maxIterations || Infinity)) {
        return prevIndex + 1
      } else {
        clearInterval(interval)
        if (onComplete) onComplete()
        return prevIndex
      }
    })
  }, duration)

  return () => clearInterval(interval)
}

export const validateMobile = (inputValue: string) => {
  const phoneRegex = /^[6-9][0-9]{9}$/i

  return phoneRegex.test(inputValue)
}
